'use client'

import { memo } from 'react'

const VaultRatingsEmpty = () => {
  return <span className="text-foreground text-xs">No ratings available for this vault.</span>
}

export default memo(VaultRatingsEmpty)
